import React from "react";
import { withStyles } from "material-ui/styles";
import Button from "material-ui/Button";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle
} from "material-ui/Dialog";
import isMobile from "ismobilejs";

const browserStyles = theme => {
  return {
    dialogContent: {
      width: 700
    },
    label: {
      padding: "0 15px 3px 7px",
      borderBottom: `2px solid ${theme.palette.answer.borderColor}`
    },
    buttonsDiv: {
      marginTop: 20
    },
    itemBtn: {
      margin: 10,
      padding: "8px 15px"
    },
    itemBtnRaised: {
      backgroundColor: theme.palette.answer.dark,
      "&:hover": {
        backgroundColor: theme.palette.answer.light,
        boxShadow: "2px 3px 7px rgba(0,0,0,0.4);"
      }
    },
    selectedItemBtnRaised: {
      backgroundColor: theme.palette.answer.light,
      boxShadow: "2px 3px 7px rgba(0,0,0,0.4);",
      "&:hover": {
        backgroundColor: theme.palette.answer.light
      }
    }
  };
};

const mobileStyles = theme => {
  return {
    dialogTitle: {
      padding: 10
    },
    dialogContent: {
      padding: 10
    },
    label: {
      padding: 2,
      borderBottom: `2px solid ${theme.palette.answer.borderColor}`
    },
    buttonsDiv: {
      marginTop: 10,
      display: "grid"
    },
    itemBtn: {
      margin: 10,
      padding: "8px 15px"
    },
    itemBtnRaised: {
      backgroundColor: theme.palette.answer.dark,
      "&:hover": {
        backgroundColor: theme.palette.answer.light,
        boxShadow: "2px 3px 7px rgba(0,0,0,0.4);"
      }
    },
    selectedItemBtnRaised: {
      backgroundColor: theme.palette.answer.light,
      boxShadow: "2px 3px 7px rgba(0,0,0,0.4);",
      "&:hover": {
        backgroundColor: theme.palette.answer.light
      }
    }
  };
};

const AttrEditDialog = props => {
  const { classes, attrEditDialog } = props;
  const { open, surveyAttr, selectedAttrItem } = attrEditDialog;
  const { order, attrName, attrItems } = surveyAttr;
  const { handleSelect, handleSubmit, handleClose } = props; // action

  return (
    <Dialog open={open}>
      <DialogTitle className={classes.dialogTitle}>回答の編集</DialogTitle>

      <DialogContent className={classes.dialogContent}>
        <div>
          <span className={classes.label}>{`${order}. ${attrName}`}</span>
        </div>

        <div className={classes.buttonsDiv}>
          {attrItems.map(item => (
            <Button
              raised
              dense
              key={item.id}
              onClick={() => handleSelect(item)}
              className={classes.itemBtn}
              classes={{
                raised:
                  item.id === selectedAttrItem.id
                    ? classes.selectedItemBtnRaised
                    : classes.itemBtnRaised
              }}
            >
              {item.itemName}
            </Button>
          ))}
        </div>
      </DialogContent>

      <DialogActions>
        <Button raised={!isMobile.any} onClick={handleClose}>
          キャンセル
        </Button>

        <Button
          raised={!isMobile.any}
          onClick={handleSubmit(surveyAttr, selectedAttrItem)}
        >
          決定
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(isMobile.any ? mobileStyles : browserStyles)(
  AttrEditDialog
);



// WEBPACK FOOTER //
// ./src/components/answer/AttrEditDialog.jsx